import { RuntimeEnvironment } from '../../enums/RuntimeEnvironment';

export const normalizeRuntimeEnvironmentValue = (value: unknown): RuntimeEnvironment | null => {
    const normalized = String(value || '')
        .trim()
        .toLowerCase();

    if (!normalized) {
        return null;
    }

    if (
        normalized === 'development' ||
        normalized === 'development-2' ||
        normalized === 'development_2' ||
        normalized === 'development2' ||
        normalized === 'dev' ||
        normalized === 'dev2'
    ) {
        return RuntimeEnvironment.DEVELOPMENT;
    }

    if (
        normalized === 'preview' ||
        normalized === 'preview-2' ||
        normalized === 'preview_2' ||
        normalized === 'preview2' ||
        normalized === 'prev' ||
        normalized === 'prev2'
    ) {
        return RuntimeEnvironment.PREVIEW;
    }

    if (normalized === 'production' || normalized === 'prod') {
        return RuntimeEnvironment.PRODUCTION;
    }

    return null;
};

export const resolveRuntimeEnvironmentFromValues = (values: unknown[]): RuntimeEnvironment => {
    for (const value of values) {
        const normalized = normalizeRuntimeEnvironmentValue(value);
        if (normalized) {
            return normalized;
        }
    }

    return RuntimeEnvironment.PRODUCTION;
};

export const resolveRuntimeEnvironment = (): RuntimeEnvironment => {
    return resolveRuntimeEnvironmentFromValues([
        process.env.CHATTENGER_RUNTIME_ENV,
        process.env.NEXT_PUBLIC_CHATTENGER_RUNTIME_ENV,
        process.env.APP_VARIANT,
        process.env.EXPO_APP_VARIANT,
        process.env.NODE_ENV,
    ]);
};

export const resolveBuildMarker = (): string | null => {
    const value = String(
        process.env.CHATTENGER_BUILD_MARKER || process.env.EXPO_PUBLIC_BUILD_MARKER || process.env.NEXT_PUBLIC_CHATTENGER_BUILD_MARKER || ''
    ).trim();

    return value || null;
};

export const resolveRollbarClientToken = (): string => {
    return String(process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN || '').trim();
};

export const resolveRollbarServerToken = (): string => {
    return String(process.env.ROLLBAR_SERVER_TOKEN || '').trim();
};
